/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    ApiKeyListDto,
    AssignmentCount,
    ChangeControlProgramRightsForUserBody,
    ChangePushReportRecipientBody,
    ChangePushReportResponsibleBody,
    ChangeUserEmailBody,
    ChangeUserGroupUsersForUserBody,
    ControlOperationFailedError,
    ControlProgramForUserListDto,
    ControlResultAssignmentsChanges,
    ControlResultOperationFailedError,
    ControlResultOverviewListDto,
    CreateUserData,
    EntitiesAccessRightsUpdateResult,
    EntityForUserListDto,
    GetUsersAssignmentCounts200,
    GetUsersParams,
    GetUsersUserIdControlsParams,
    GetUsersUserIdPendingControlResultsParams,
    OAuthClientId,
    OAuthConnectionView,
    PartialControlForUserListDto,
    PatchUsersUserIdControlsBody,
    PersonalAccessTokenListDto,
    PushReportConfigurationForUserListDto,
    RemoveControlEntityRightsForUserBody,
    RiskDirectoryForUserListDto,
    SavedReportForUserListDto,
    SimpleTestingControlListDto,
    TActTableRowListDto,
    TestingProgramForUserListDto,
    UpdatableUserWithDetails,
    UpdatableUsers,
    UpdateEntityRightsForUserBody,
    UpdateRiskDirectoryRightsForUserBody,
    UpdateSavedReportRightsForUserBody,
    UserId,
    UserListResponse,
    UserViewDto,
    UserWithSettingsResource,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getUsersUserIdOauthConnections = (
    userId: UserId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<OAuthConnectionView[]>> => {
    return axios.get(`/api/users/${userId}/oauth-connections`, options);
};

export const getGetUsersUserIdOauthConnectionsQueryKey = (userId: UserId) => {
    return [`/api/users/${userId}/oauth-connections`] as const;
};

export const getGetUsersUserIdOauthConnectionsQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdOauthConnectionsQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>
    > = ({ signal }) =>
        getUsersUserIdOauthConnections(userId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdOauthConnectionsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>
>;
export type GetUsersUserIdOauthConnectionsQueryError = AxiosError<unknown>;

export function useGetUsersUserIdOauthConnections<
    TData = Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdOauthConnections<
    TData = Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdOauthConnections<
    TData = Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdOauthConnections<
    TData = Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdOauthConnectionsQueryOptions(
        userId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersUserIdOauthConnectionsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdOauthConnectionsQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>
    > = ({ signal }) =>
        getUsersUserIdOauthConnections(userId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdOauthConnectionsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>
>;
export type GetUsersUserIdOauthConnectionsSuspenseQueryError =
    AxiosError<unknown>;

export function useGetUsersUserIdOauthConnectionsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdOauthConnectionsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdOauthConnectionsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdOauthConnectionsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdOauthConnections>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdOauthConnectionsSuspenseQueryOptions(
        userId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const deleteUsersUserIdOauthConnectionsClientId = (
    userId: UserId,
    clientId: OAuthClientId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.delete(
        `/api/users/${userId}/oauth-connections/${clientId}`,
        options
    );
};

export const getDeleteUsersUserIdOauthConnectionsClientIdMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteUsersUserIdOauthConnectionsClientId>>,
        TError,
        { userId: UserId; clientId: OAuthClientId },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteUsersUserIdOauthConnectionsClientId>>,
    TError,
    { userId: UserId; clientId: OAuthClientId },
    TContext
> => {
    const mutationKey = ["deleteUsersUserIdOauthConnectionsClientId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteUsersUserIdOauthConnectionsClientId>>,
        { userId: UserId; clientId: OAuthClientId }
    > = (props) => {
        const { userId, clientId } = props ?? {};

        return deleteUsersUserIdOauthConnectionsClientId(
            userId,
            clientId,
            axiosOptions
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteUsersUserIdOauthConnectionsClientIdMutationResult =
    NonNullable<
        Awaited<ReturnType<typeof deleteUsersUserIdOauthConnectionsClientId>>
    >;

export type DeleteUsersUserIdOauthConnectionsClientIdMutationError =
    AxiosError<unknown>;

export const useDeleteUsersUserIdOauthConnectionsClientId = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<
                ReturnType<typeof deleteUsersUserIdOauthConnectionsClientId>
            >,
            TError,
            { userId: UserId; clientId: OAuthClientId },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof deleteUsersUserIdOauthConnectionsClientId>>,
    TError,
    { userId: UserId; clientId: OAuthClientId },
    TContext
> => {
    return useMutation(
        getDeleteUsersUserIdOauthConnectionsClientIdMutationOptions(options),
        queryClient
    );
};
export const getUsersUserIdPushReportsResponsible = (
    userId: UserId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<PushReportConfigurationForUserListDto>> => {
    return axios.get(`/api/users/${userId}/push-reports/responsible`, options);
};

export const getGetUsersUserIdPushReportsResponsibleQueryKey = (
    userId: UserId
) => {
    return [`/api/users/${userId}/push-reports/responsible`] as const;
};

export const getGetUsersUserIdPushReportsResponsibleQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsResponsible>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getUsersUserIdPushReportsResponsible>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdPushReportsResponsibleQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdPushReportsResponsible>>
    > = ({ signal }) =>
        getUsersUserIdPushReportsResponsible(userId, {
            signal,
            ...axiosOptions,
        });

    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdPushReportsResponsible>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdPushReportsResponsibleQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdPushReportsResponsible>>
>;
export type GetUsersUserIdPushReportsResponsibleQueryError =
    AxiosError<unknown>;

export function useGetUsersUserIdPushReportsResponsible<
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsResponsible>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getUsersUserIdPushReportsResponsible>
                >,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getUsersUserIdPushReportsResponsible>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getUsersUserIdPushReportsResponsible>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdPushReportsResponsible<
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsResponsible>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getUsersUserIdPushReportsResponsible>
                >,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getUsersUserIdPushReportsResponsible>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getUsersUserIdPushReportsResponsible>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdPushReportsResponsible<
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsResponsible>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getUsersUserIdPushReportsResponsible>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdPushReportsResponsible<
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsResponsible>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<
                    ReturnType<typeof getUsersUserIdPushReportsResponsible>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdPushReportsResponsibleQueryOptions(
        userId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersUserIdPushReportsResponsibleSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsResponsible>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getUsersUserIdPushReportsResponsible>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdPushReportsResponsibleQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdPushReportsResponsible>>
    > = ({ signal }) =>
        getUsersUserIdPushReportsResponsible(userId, {
            signal,
            ...axiosOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdPushReportsResponsible>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdPushReportsResponsibleSuspenseQueryResult =
    NonNullable<
        Awaited<ReturnType<typeof getUsersUserIdPushReportsResponsible>>
    >;
export type GetUsersUserIdPushReportsResponsibleSuspenseQueryError =
    AxiosError<unknown>;

export function useGetUsersUserIdPushReportsResponsibleSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsResponsible>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getUsersUserIdPushReportsResponsible>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdPushReportsResponsibleSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsResponsible>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getUsersUserIdPushReportsResponsible>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdPushReportsResponsibleSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsResponsible>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getUsersUserIdPushReportsResponsible>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdPushReportsResponsibleSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsResponsible>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<
                    ReturnType<typeof getUsersUserIdPushReportsResponsible>
                >,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetUsersUserIdPushReportsResponsibleSuspenseQueryOptions(
            userId,
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const patchUsersUserIdPushReportsResponsible = (
    userId: UserId,
    changePushReportResponsibleBody: ChangePushReportResponsibleBody,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.patch(
        `/api/users/${userId}/push-reports/responsible`,
        changePushReportResponsibleBody,
        options
    );
};

export const getPatchUsersUserIdPushReportsResponsibleMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchUsersUserIdPushReportsResponsible>>,
        TError,
        { userId: UserId; data: ChangePushReportResponsibleBody },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchUsersUserIdPushReportsResponsible>>,
    TError,
    { userId: UserId; data: ChangePushReportResponsibleBody },
    TContext
> => {
    const mutationKey = ["patchUsersUserIdPushReportsResponsible"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchUsersUserIdPushReportsResponsible>>,
        { userId: UserId; data: ChangePushReportResponsibleBody }
    > = (props) => {
        const { userId, data } = props ?? {};

        return patchUsersUserIdPushReportsResponsible(
            userId,
            data,
            axiosOptions
        );
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchUsersUserIdPushReportsResponsibleMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchUsersUserIdPushReportsResponsible>>
>;
export type PatchUsersUserIdPushReportsResponsibleMutationBody =
    ChangePushReportResponsibleBody;
export type PatchUsersUserIdPushReportsResponsibleMutationError =
    AxiosError<unknown>;

export const usePatchUsersUserIdPushReportsResponsible = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchUsersUserIdPushReportsResponsible>>,
            TError,
            { userId: UserId; data: ChangePushReportResponsibleBody },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchUsersUserIdPushReportsResponsible>>,
    TError,
    { userId: UserId; data: ChangePushReportResponsibleBody },
    TContext
> => {
    return useMutation(
        getPatchUsersUserIdPushReportsResponsibleMutationOptions(options),
        queryClient
    );
};
export const getUsersUserIdPushReportsRecipient = (
    userId: UserId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<PushReportConfigurationForUserListDto>> => {
    return axios.get(`/api/users/${userId}/push-reports/recipient`, options);
};

export const getGetUsersUserIdPushReportsRecipientQueryKey = (
    userId: UserId
) => {
    return [`/api/users/${userId}/push-reports/recipient`] as const;
};

export const getGetUsersUserIdPushReportsRecipientQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdPushReportsRecipientQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>
    > = ({ signal }) =>
        getUsersUserIdPushReportsRecipient(userId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdPushReportsRecipientQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>
>;
export type GetUsersUserIdPushReportsRecipientQueryError = AxiosError<unknown>;

export function useGetUsersUserIdPushReportsRecipient<
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getUsersUserIdPushReportsRecipient>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getUsersUserIdPushReportsRecipient>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdPushReportsRecipient<
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getUsersUserIdPushReportsRecipient>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getUsersUserIdPushReportsRecipient>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdPushReportsRecipient<
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdPushReportsRecipient<
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdPushReportsRecipientQueryOptions(
        userId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersUserIdPushReportsRecipientSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdPushReportsRecipientQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>
    > = ({ signal }) =>
        getUsersUserIdPushReportsRecipient(userId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdPushReportsRecipientSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>
>;
export type GetUsersUserIdPushReportsRecipientSuspenseQueryError =
    AxiosError<unknown>;

export function useGetUsersUserIdPushReportsRecipientSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdPushReportsRecipientSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdPushReportsRecipientSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdPushReportsRecipientSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPushReportsRecipient>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetUsersUserIdPushReportsRecipientSuspenseQueryOptions(
            userId,
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const patchUsersUserIdPushReportsRecipient = (
    userId: UserId,
    changePushReportRecipientBody: ChangePushReportRecipientBody,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.patch(
        `/api/users/${userId}/push-reports/recipient`,
        changePushReportRecipientBody,
        options
    );
};

export const getPatchUsersUserIdPushReportsRecipientMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchUsersUserIdPushReportsRecipient>>,
        TError,
        { userId: UserId; data: ChangePushReportRecipientBody },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchUsersUserIdPushReportsRecipient>>,
    TError,
    { userId: UserId; data: ChangePushReportRecipientBody },
    TContext
> => {
    const mutationKey = ["patchUsersUserIdPushReportsRecipient"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchUsersUserIdPushReportsRecipient>>,
        { userId: UserId; data: ChangePushReportRecipientBody }
    > = (props) => {
        const { userId, data } = props ?? {};

        return patchUsersUserIdPushReportsRecipient(userId, data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchUsersUserIdPushReportsRecipientMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchUsersUserIdPushReportsRecipient>>
>;
export type PatchUsersUserIdPushReportsRecipientMutationBody =
    ChangePushReportRecipientBody;
export type PatchUsersUserIdPushReportsRecipientMutationError =
    AxiosError<unknown>;

export const usePatchUsersUserIdPushReportsRecipient = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchUsersUserIdPushReportsRecipient>>,
            TError,
            { userId: UserId; data: ChangePushReportRecipientBody },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchUsersUserIdPushReportsRecipient>>,
    TError,
    { userId: UserId; data: ChangePushReportRecipientBody },
    TContext
> => {
    return useMutation(
        getPatchUsersUserIdPushReportsRecipientMutationOptions(options),
        queryClient
    );
};
export const getUsersUserId = (
    userId: UserId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<UserViewDto>> => {
    return axios.get(`/api/users/${userId}`, options);
};

export const getGetUsersUserIdQueryKey = (userId: UserId) => {
    return [`/api/users/${userId}`] as const;
};

export const getGetUsersUserIdQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetUsersUserIdQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserId>>
    > = ({ signal }) => getUsersUserId(userId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserId>>
>;
export type GetUsersUserIdQueryError = AxiosError<unknown>;

export function useGetUsersUserId<
    TData = Awaited<ReturnType<typeof getUsersUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserId>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserId>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserId>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserId<
    TData = Awaited<ReturnType<typeof getUsersUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserId>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserId>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserId>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserId<
    TData = Awaited<ReturnType<typeof getUsersUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserId<
    TData = Awaited<ReturnType<typeof getUsersUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdQueryOptions(userId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersUserIdSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetUsersUserIdQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserId>>
    > = ({ signal }) => getUsersUserId(userId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserId>>
>;
export type GetUsersUserIdSuspenseQueryError = AxiosError<unknown>;

export function useGetUsersUserIdSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserId>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdSuspenseQueryOptions(userId, options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const deleteUsersUserId = (
    userId: UserId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.delete(`/api/users/${userId}`, options);
};

export const getDeleteUsersUserIdMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteUsersUserId>>,
        TError,
        { userId: UserId },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteUsersUserId>>,
    TError,
    { userId: UserId },
    TContext
> => {
    const mutationKey = ["deleteUsersUserId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteUsersUserId>>,
        { userId: UserId }
    > = (props) => {
        const { userId } = props ?? {};

        return deleteUsersUserId(userId, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteUsersUserIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteUsersUserId>>
>;

export type DeleteUsersUserIdMutationError = AxiosError<unknown>;

export const useDeleteUsersUserId = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteUsersUserId>>,
            TError,
            { userId: UserId },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof deleteUsersUserId>>,
    TError,
    { userId: UserId },
    TContext
> => {
    return useMutation(
        getDeleteUsersUserIdMutationOptions(options),
        queryClient
    );
};
export const patchUsersUserId = (
    userId: UserId,
    updatableUserWithDetails: UpdatableUserWithDetails,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<UserViewDto>> => {
    return axios.patch(
        `/api/users/${userId}`,
        updatableUserWithDetails,
        options
    );
};

export const getPatchUsersUserIdMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchUsersUserId>>,
        TError,
        { userId: UserId; data: UpdatableUserWithDetails },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchUsersUserId>>,
    TError,
    { userId: UserId; data: UpdatableUserWithDetails },
    TContext
> => {
    const mutationKey = ["patchUsersUserId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchUsersUserId>>,
        { userId: UserId; data: UpdatableUserWithDetails }
    > = (props) => {
        const { userId, data } = props ?? {};

        return patchUsersUserId(userId, data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchUsersUserIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchUsersUserId>>
>;
export type PatchUsersUserIdMutationBody = UpdatableUserWithDetails;
export type PatchUsersUserIdMutationError = AxiosError<unknown>;

export const usePatchUsersUserId = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchUsersUserId>>,
            TError,
            { userId: UserId; data: UpdatableUserWithDetails },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchUsersUserId>>,
    TError,
    { userId: UserId; data: UpdatableUserWithDetails },
    TContext
> => {
    return useMutation(
        getPatchUsersUserIdMutationOptions(options),
        queryClient
    );
};
export const getUsersUserIdApiKeys = (
    userId: UserId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ApiKeyListDto>> => {
    return axios.get(`/api/users/${userId}/api-keys`, options);
};

export const getGetUsersUserIdApiKeysQueryKey = (userId: UserId) => {
    return [`/api/users/${userId}/api-keys`] as const;
};

export const getGetUsersUserIdApiKeysQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetUsersUserIdApiKeysQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdApiKeys>>
    > = ({ signal }) =>
        getUsersUserIdApiKeys(userId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdApiKeysQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdApiKeys>>
>;
export type GetUsersUserIdApiKeysQueryError = AxiosError<unknown>;

export function useGetUsersUserIdApiKeys<
    TData = Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdApiKeys>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdApiKeys<
    TData = Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdApiKeys>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdApiKeys<
    TData = Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdApiKeys<
    TData = Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdApiKeysQueryOptions(userId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersUserIdApiKeysSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetUsersUserIdApiKeysQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdApiKeys>>
    > = ({ signal }) =>
        getUsersUserIdApiKeys(userId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdApiKeysSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdApiKeys>>
>;
export type GetUsersUserIdApiKeysSuspenseQueryError = AxiosError<unknown>;

export function useGetUsersUserIdApiKeysSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdApiKeysSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdApiKeysSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdApiKeysSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdApiKeys>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdApiKeysSuspenseQueryOptions(
        userId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getUsersUserIdAssignmentCount = (
    userId: UserId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<AssignmentCount>> => {
    return axios.get(`/api/users/${userId}/assignment-count`, options);
};

export const getGetUsersUserIdAssignmentCountQueryKey = (userId: UserId) => {
    return [`/api/users/${userId}/assignment-count`] as const;
};

export const getGetUsersUserIdAssignmentCountQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdAssignmentCountQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>
    > = ({ signal }) =>
        getUsersUserIdAssignmentCount(userId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdAssignmentCountQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>
>;
export type GetUsersUserIdAssignmentCountQueryError = AxiosError<unknown>;

export function useGetUsersUserIdAssignmentCount<
    TData = Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdAssignmentCount<
    TData = Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdAssignmentCount<
    TData = Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdAssignmentCount<
    TData = Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdAssignmentCountQueryOptions(
        userId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersUserIdAssignmentCountSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdAssignmentCountQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>
    > = ({ signal }) =>
        getUsersUserIdAssignmentCount(userId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdAssignmentCountSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>
>;
export type GetUsersUserIdAssignmentCountSuspenseQueryError =
    AxiosError<unknown>;

export function useGetUsersUserIdAssignmentCountSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdAssignmentCountSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdAssignmentCountSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdAssignmentCountSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdAssignmentCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdAssignmentCountSuspenseQueryOptions(
        userId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getUsersUserIdControls = (
    userId: UserId,
    params?: GetUsersUserIdControlsParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<PartialControlForUserListDto>> => {
    return axios.get(`/api/users/${userId}/controls`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetUsersUserIdControlsQueryKey = (
    userId: UserId,
    params?: GetUsersUserIdControlsParams
) => {
    return [
        `/api/users/${userId}/controls`,
        ...(params ? [params] : []),
    ] as const;
};

export const getGetUsersUserIdControlsQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdControls>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params?: GetUsersUserIdControlsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdControlsQueryKey(userId, params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdControls>>
    > = ({ signal }) =>
        getUsersUserIdControls(userId, params, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdControls>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdControlsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdControls>>
>;
export type GetUsersUserIdControlsQueryError = AxiosError<unknown>;

export function useGetUsersUserIdControls<
    TData = Awaited<ReturnType<typeof getUsersUserIdControls>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params: undefined | GetUsersUserIdControlsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControls>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdControls>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdControls>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdControls<
    TData = Awaited<ReturnType<typeof getUsersUserIdControls>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params?: GetUsersUserIdControlsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControls>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdControls>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdControls>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdControls<
    TData = Awaited<ReturnType<typeof getUsersUserIdControls>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params?: GetUsersUserIdControlsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdControls<
    TData = Awaited<ReturnType<typeof getUsersUserIdControls>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params?: GetUsersUserIdControlsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdControlsQueryOptions(
        userId,
        params,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersUserIdControlsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdControls>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params?: GetUsersUserIdControlsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdControlsQueryKey(userId, params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdControls>>
    > = ({ signal }) =>
        getUsersUserIdControls(userId, params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdControls>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdControlsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdControls>>
>;
export type GetUsersUserIdControlsSuspenseQueryError = AxiosError<unknown>;

export function useGetUsersUserIdControlsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdControls>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params: undefined | GetUsersUserIdControlsParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdControlsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdControls>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params?: GetUsersUserIdControlsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdControlsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdControls>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params?: GetUsersUserIdControlsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdControlsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdControls>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params?: GetUsersUserIdControlsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdControlsSuspenseQueryOptions(
        userId,
        params,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const patchUsersUserIdControls = (
    userId: UserId,
    patchUsersUserIdControlsBody: PatchUsersUserIdControlsBody,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.patch(
        `/api/users/${userId}/controls`,
        patchUsersUserIdControlsBody,
        options
    );
};

export const getPatchUsersUserIdControlsMutationOptions = <
    TError = AxiosError<ControlOperationFailedError>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchUsersUserIdControls>>,
        TError,
        { userId: UserId; data: PatchUsersUserIdControlsBody },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchUsersUserIdControls>>,
    TError,
    { userId: UserId; data: PatchUsersUserIdControlsBody },
    TContext
> => {
    const mutationKey = ["patchUsersUserIdControls"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchUsersUserIdControls>>,
        { userId: UserId; data: PatchUsersUserIdControlsBody }
    > = (props) => {
        const { userId, data } = props ?? {};

        return patchUsersUserIdControls(userId, data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchUsersUserIdControlsMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchUsersUserIdControls>>
>;
export type PatchUsersUserIdControlsMutationBody = PatchUsersUserIdControlsBody;
export type PatchUsersUserIdControlsMutationError =
    AxiosError<ControlOperationFailedError>;

export const usePatchUsersUserIdControls = <
    TError = AxiosError<ControlOperationFailedError>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchUsersUserIdControls>>,
            TError,
            { userId: UserId; data: PatchUsersUserIdControlsBody },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchUsersUserIdControls>>,
    TError,
    { userId: UserId; data: PatchUsersUserIdControlsBody },
    TContext
> => {
    return useMutation(
        getPatchUsersUserIdControlsMutationOptions(options),
        queryClient
    );
};
export const getUsersUserIdControlEntities = (
    userId: UserId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<EntityForUserListDto>> => {
    return axios.get(`/api/users/${userId}/control-entities`, options);
};

export const getGetUsersUserIdControlEntitiesQueryKey = (userId: UserId) => {
    return [`/api/users/${userId}/control-entities`] as const;
};

export const getGetUsersUserIdControlEntitiesQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdControlEntitiesQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdControlEntities>>
    > = ({ signal }) =>
        getUsersUserIdControlEntities(userId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdControlEntitiesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdControlEntities>>
>;
export type GetUsersUserIdControlEntitiesQueryError = AxiosError<unknown>;

export function useGetUsersUserIdControlEntities<
    TData = Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdControlEntities>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdControlEntities<
    TData = Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdControlEntities>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdControlEntities<
    TData = Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdControlEntities<
    TData = Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdControlEntitiesQueryOptions(
        userId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersUserIdControlEntitiesSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdControlEntitiesQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdControlEntities>>
    > = ({ signal }) =>
        getUsersUserIdControlEntities(userId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdControlEntitiesSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdControlEntities>>
>;
export type GetUsersUserIdControlEntitiesSuspenseQueryError =
    AxiosError<unknown>;

export function useGetUsersUserIdControlEntitiesSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdControlEntitiesSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdControlEntitiesSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdControlEntitiesSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdControlEntitiesSuspenseQueryOptions(
        userId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const patchUsersUserIdControlEntities = (
    userId: UserId,
    removeControlEntityRightsForUserBody: RemoveControlEntityRightsForUserBody,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<EntitiesAccessRightsUpdateResult>> => {
    return axios.patch(
        `/api/users/${userId}/control-entities`,
        removeControlEntityRightsForUserBody,
        options
    );
};

export const getPatchUsersUserIdControlEntitiesMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchUsersUserIdControlEntities>>,
        TError,
        { userId: UserId; data: RemoveControlEntityRightsForUserBody },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchUsersUserIdControlEntities>>,
    TError,
    { userId: UserId; data: RemoveControlEntityRightsForUserBody },
    TContext
> => {
    const mutationKey = ["patchUsersUserIdControlEntities"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchUsersUserIdControlEntities>>,
        { userId: UserId; data: RemoveControlEntityRightsForUserBody }
    > = (props) => {
        const { userId, data } = props ?? {};

        return patchUsersUserIdControlEntities(userId, data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchUsersUserIdControlEntitiesMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchUsersUserIdControlEntities>>
>;
export type PatchUsersUserIdControlEntitiesMutationBody =
    RemoveControlEntityRightsForUserBody;
export type PatchUsersUserIdControlEntitiesMutationError = AxiosError<unknown>;

export const usePatchUsersUserIdControlEntities = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchUsersUserIdControlEntities>>,
            TError,
            { userId: UserId; data: RemoveControlEntityRightsForUserBody },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchUsersUserIdControlEntities>>,
    TError,
    { userId: UserId; data: RemoveControlEntityRightsForUserBody },
    TContext
> => {
    return useMutation(
        getPatchUsersUserIdControlEntitiesMutationOptions(options),
        queryClient
    );
};
export const getUsersUserIdControlPrograms = (
    userId: UserId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlProgramForUserListDto>> => {
    return axios.get(`/api/users/${userId}/control-programs`, options);
};

export const getGetUsersUserIdControlProgramsQueryKey = (userId: UserId) => {
    return [`/api/users/${userId}/control-programs`] as const;
};

export const getGetUsersUserIdControlProgramsQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdControlProgramsQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>
    > = ({ signal }) =>
        getUsersUserIdControlPrograms(userId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdControlProgramsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>
>;
export type GetUsersUserIdControlProgramsQueryError = AxiosError<unknown>;

export function useGetUsersUserIdControlPrograms<
    TData = Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdControlPrograms<
    TData = Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdControlPrograms<
    TData = Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdControlPrograms<
    TData = Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdControlProgramsQueryOptions(
        userId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersUserIdControlProgramsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdControlProgramsQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>
    > = ({ signal }) =>
        getUsersUserIdControlPrograms(userId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdControlProgramsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>
>;
export type GetUsersUserIdControlProgramsSuspenseQueryError =
    AxiosError<unknown>;

export function useGetUsersUserIdControlProgramsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdControlProgramsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdControlProgramsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdControlProgramsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdControlPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdControlProgramsSuspenseQueryOptions(
        userId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const patchUsersUserIdControlPrograms = (
    userId: UserId,
    changeControlProgramRightsForUserBody: ChangeControlProgramRightsForUserBody,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.patch(
        `/api/users/${userId}/control-programs`,
        changeControlProgramRightsForUserBody,
        options
    );
};

export const getPatchUsersUserIdControlProgramsMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchUsersUserIdControlPrograms>>,
        TError,
        { userId: UserId; data: ChangeControlProgramRightsForUserBody },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchUsersUserIdControlPrograms>>,
    TError,
    { userId: UserId; data: ChangeControlProgramRightsForUserBody },
    TContext
> => {
    const mutationKey = ["patchUsersUserIdControlPrograms"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchUsersUserIdControlPrograms>>,
        { userId: UserId; data: ChangeControlProgramRightsForUserBody }
    > = (props) => {
        const { userId, data } = props ?? {};

        return patchUsersUserIdControlPrograms(userId, data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchUsersUserIdControlProgramsMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchUsersUserIdControlPrograms>>
>;
export type PatchUsersUserIdControlProgramsMutationBody =
    ChangeControlProgramRightsForUserBody;
export type PatchUsersUserIdControlProgramsMutationError = AxiosError<unknown>;

export const usePatchUsersUserIdControlPrograms = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchUsersUserIdControlPrograms>>,
            TError,
            { userId: UserId; data: ChangeControlProgramRightsForUserBody },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchUsersUserIdControlPrograms>>,
    TError,
    { userId: UserId; data: ChangeControlProgramRightsForUserBody },
    TContext
> => {
    return useMutation(
        getPatchUsersUserIdControlProgramsMutationOptions(options),
        queryClient
    );
};
export const patchUsersUserIdControlResults = (
    userId: UserId,
    controlResultAssignmentsChanges: ControlResultAssignmentsChanges,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlResultOverviewListDto>> => {
    return axios.patch(
        `/api/users/${userId}/control-results`,
        controlResultAssignmentsChanges,
        options
    );
};

export const getPatchUsersUserIdControlResultsMutationOptions = <
    TError = AxiosError<ControlResultOperationFailedError>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchUsersUserIdControlResults>>,
        TError,
        { userId: UserId; data: ControlResultAssignmentsChanges },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchUsersUserIdControlResults>>,
    TError,
    { userId: UserId; data: ControlResultAssignmentsChanges },
    TContext
> => {
    const mutationKey = ["patchUsersUserIdControlResults"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchUsersUserIdControlResults>>,
        { userId: UserId; data: ControlResultAssignmentsChanges }
    > = (props) => {
        const { userId, data } = props ?? {};

        return patchUsersUserIdControlResults(userId, data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchUsersUserIdControlResultsMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchUsersUserIdControlResults>>
>;
export type PatchUsersUserIdControlResultsMutationBody =
    ControlResultAssignmentsChanges;
export type PatchUsersUserIdControlResultsMutationError =
    AxiosError<ControlResultOperationFailedError>;

export const usePatchUsersUserIdControlResults = <
    TError = AxiosError<ControlResultOperationFailedError>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchUsersUserIdControlResults>>,
            TError,
            { userId: UserId; data: ControlResultAssignmentsChanges },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchUsersUserIdControlResults>>,
    TError,
    { userId: UserId; data: ControlResultAssignmentsChanges },
    TContext
> => {
    return useMutation(
        getPatchUsersUserIdControlResultsMutationOptions(options),
        queryClient
    );
};
export const getUsersUserIdEntities = (
    userId: UserId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<EntityForUserListDto>> => {
    return axios.get(`/api/users/${userId}/entities`, options);
};

export const getGetUsersUserIdEntitiesQueryKey = (userId: UserId) => {
    return [`/api/users/${userId}/entities`] as const;
};

export const getGetUsersUserIdEntitiesQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetUsersUserIdEntitiesQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdEntities>>
    > = ({ signal }) =>
        getUsersUserIdEntities(userId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdEntities>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdEntitiesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdEntities>>
>;
export type GetUsersUserIdEntitiesQueryError = AxiosError<unknown>;

export function useGetUsersUserIdEntities<
    TData = Awaited<ReturnType<typeof getUsersUserIdEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdEntities>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdEntities>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdEntities>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdEntities<
    TData = Awaited<ReturnType<typeof getUsersUserIdEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdEntities>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdEntities>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdEntities>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdEntities<
    TData = Awaited<ReturnType<typeof getUsersUserIdEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdEntities<
    TData = Awaited<ReturnType<typeof getUsersUserIdEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdEntitiesQueryOptions(userId, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersUserIdEntitiesSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetUsersUserIdEntitiesQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdEntities>>
    > = ({ signal }) =>
        getUsersUserIdEntities(userId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdEntities>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdEntitiesSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdEntities>>
>;
export type GetUsersUserIdEntitiesSuspenseQueryError = AxiosError<unknown>;

export function useGetUsersUserIdEntitiesSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdEntitiesSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdEntitiesSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdEntitiesSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdEntities>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdEntities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdEntitiesSuspenseQueryOptions(
        userId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const patchUsersUserIdEntities = (
    userId: UserId,
    updateEntityRightsForUserBody: UpdateEntityRightsForUserBody,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.patch(
        `/api/users/${userId}/entities`,
        updateEntityRightsForUserBody,
        options
    );
};

export const getPatchUsersUserIdEntitiesMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchUsersUserIdEntities>>,
        TError,
        { userId: UserId; data: UpdateEntityRightsForUserBody },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchUsersUserIdEntities>>,
    TError,
    { userId: UserId; data: UpdateEntityRightsForUserBody },
    TContext
> => {
    const mutationKey = ["patchUsersUserIdEntities"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchUsersUserIdEntities>>,
        { userId: UserId; data: UpdateEntityRightsForUserBody }
    > = (props) => {
        const { userId, data } = props ?? {};

        return patchUsersUserIdEntities(userId, data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchUsersUserIdEntitiesMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchUsersUserIdEntities>>
>;
export type PatchUsersUserIdEntitiesMutationBody =
    UpdateEntityRightsForUserBody;
export type PatchUsersUserIdEntitiesMutationError = AxiosError<unknown>;

export const usePatchUsersUserIdEntities = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchUsersUserIdEntities>>,
            TError,
            { userId: UserId; data: UpdateEntityRightsForUserBody },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchUsersUserIdEntities>>,
    TError,
    { userId: UserId; data: UpdateEntityRightsForUserBody },
    TContext
> => {
    return useMutation(
        getPatchUsersUserIdEntitiesMutationOptions(options),
        queryClient
    );
};
export const getUsersUserIdPendingControlResults = (
    userId: UserId,
    params?: GetUsersUserIdPendingControlResultsParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlResultOverviewListDto>> => {
    return axios.get(`/api/users/${userId}/pending-control-results`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetUsersUserIdPendingControlResultsQueryKey = (
    userId: UserId,
    params?: GetUsersUserIdPendingControlResultsParams
) => {
    return [
        `/api/users/${userId}/pending-control-results`,
        ...(params ? [params] : []),
    ] as const;
};

export const getGetUsersUserIdPendingControlResultsQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params?: GetUsersUserIdPendingControlResultsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdPendingControlResultsQueryKey(userId, params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>
    > = ({ signal }) =>
        getUsersUserIdPendingControlResults(userId, params, {
            signal,
            ...axiosOptions,
        });

    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdPendingControlResultsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>
>;
export type GetUsersUserIdPendingControlResultsQueryError = AxiosError<unknown>;

export function useGetUsersUserIdPendingControlResults<
    TData = Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params: undefined | GetUsersUserIdPendingControlResultsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getUsersUserIdPendingControlResults>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getUsersUserIdPendingControlResults>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdPendingControlResults<
    TData = Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params?: GetUsersUserIdPendingControlResultsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getUsersUserIdPendingControlResults>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getUsersUserIdPendingControlResults>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdPendingControlResults<
    TData = Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params?: GetUsersUserIdPendingControlResultsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdPendingControlResults<
    TData = Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params?: GetUsersUserIdPendingControlResultsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdPendingControlResultsQueryOptions(
        userId,
        params,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersUserIdPendingControlResultsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params?: GetUsersUserIdPendingControlResultsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdPendingControlResultsQueryKey(userId, params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>
    > = ({ signal }) =>
        getUsersUserIdPendingControlResults(userId, params, {
            signal,
            ...axiosOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdPendingControlResultsSuspenseQueryResult =
    NonNullable<
        Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>
    >;
export type GetUsersUserIdPendingControlResultsSuspenseQueryError =
    AxiosError<unknown>;

export function useGetUsersUserIdPendingControlResultsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params: undefined | GetUsersUserIdPendingControlResultsParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdPendingControlResultsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params?: GetUsersUserIdPendingControlResultsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdPendingControlResultsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params?: GetUsersUserIdPendingControlResultsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdPendingControlResultsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    params?: GetUsersUserIdPendingControlResultsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPendingControlResults>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetUsersUserIdPendingControlResultsSuspenseQueryOptions(
            userId,
            params,
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getUsersUserIdPersonalAccessTokens = (
    userId: UserId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<PersonalAccessTokenListDto>> => {
    return axios.get(`/api/users/${userId}/personal-access-tokens`, options);
};

export const getGetUsersUserIdPersonalAccessTokensQueryKey = (
    userId: UserId
) => {
    return [`/api/users/${userId}/personal-access-tokens`] as const;
};

export const getGetUsersUserIdPersonalAccessTokensQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdPersonalAccessTokensQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>
    > = ({ signal }) =>
        getUsersUserIdPersonalAccessTokens(userId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdPersonalAccessTokensQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>
>;
export type GetUsersUserIdPersonalAccessTokensQueryError = AxiosError<unknown>;

export function useGetUsersUserIdPersonalAccessTokens<
    TData = Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getUsersUserIdPersonalAccessTokens>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getUsersUserIdPersonalAccessTokens>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdPersonalAccessTokens<
    TData = Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof getUsersUserIdPersonalAccessTokens>
                    >,
                    TError,
                    Awaited<
                        ReturnType<typeof getUsersUserIdPersonalAccessTokens>
                    >
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdPersonalAccessTokens<
    TData = Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdPersonalAccessTokens<
    TData = Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdPersonalAccessTokensQueryOptions(
        userId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersUserIdPersonalAccessTokensSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdPersonalAccessTokensQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>
    > = ({ signal }) =>
        getUsersUserIdPersonalAccessTokens(userId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdPersonalAccessTokensSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>
>;
export type GetUsersUserIdPersonalAccessTokensSuspenseQueryError =
    AxiosError<unknown>;

export function useGetUsersUserIdPersonalAccessTokensSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdPersonalAccessTokensSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdPersonalAccessTokensSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdPersonalAccessTokensSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdPersonalAccessTokens>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetUsersUserIdPersonalAccessTokensSuspenseQueryOptions(
            userId,
            options
        );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getUsersUserIdRiskDirectories = (
    userId: UserId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<RiskDirectoryForUserListDto>> => {
    return axios.get(`/api/users/${userId}/risk-directories`, options);
};

export const getGetUsersUserIdRiskDirectoriesQueryKey = (userId: UserId) => {
    return [`/api/users/${userId}/risk-directories`] as const;
};

export const getGetUsersUserIdRiskDirectoriesQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdRiskDirectoriesQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>
    > = ({ signal }) =>
        getUsersUserIdRiskDirectories(userId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdRiskDirectoriesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>
>;
export type GetUsersUserIdRiskDirectoriesQueryError = AxiosError<unknown>;

export function useGetUsersUserIdRiskDirectories<
    TData = Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdRiskDirectories<
    TData = Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdRiskDirectories<
    TData = Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdRiskDirectories<
    TData = Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdRiskDirectoriesQueryOptions(
        userId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersUserIdRiskDirectoriesSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdRiskDirectoriesQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>
    > = ({ signal }) =>
        getUsersUserIdRiskDirectories(userId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdRiskDirectoriesSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>
>;
export type GetUsersUserIdRiskDirectoriesSuspenseQueryError =
    AxiosError<unknown>;

export function useGetUsersUserIdRiskDirectoriesSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdRiskDirectoriesSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdRiskDirectoriesSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdRiskDirectoriesSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdRiskDirectories>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdRiskDirectoriesSuspenseQueryOptions(
        userId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const patchUsersUserIdRiskDirectories = (
    userId: UserId,
    updateRiskDirectoryRightsForUserBody: UpdateRiskDirectoryRightsForUserBody,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.patch(
        `/api/users/${userId}/risk-directories`,
        updateRiskDirectoryRightsForUserBody,
        options
    );
};

export const getPatchUsersUserIdRiskDirectoriesMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchUsersUserIdRiskDirectories>>,
        TError,
        { userId: UserId; data: UpdateRiskDirectoryRightsForUserBody },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchUsersUserIdRiskDirectories>>,
    TError,
    { userId: UserId; data: UpdateRiskDirectoryRightsForUserBody },
    TContext
> => {
    const mutationKey = ["patchUsersUserIdRiskDirectories"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchUsersUserIdRiskDirectories>>,
        { userId: UserId; data: UpdateRiskDirectoryRightsForUserBody }
    > = (props) => {
        const { userId, data } = props ?? {};

        return patchUsersUserIdRiskDirectories(userId, data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchUsersUserIdRiskDirectoriesMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchUsersUserIdRiskDirectories>>
>;
export type PatchUsersUserIdRiskDirectoriesMutationBody =
    UpdateRiskDirectoryRightsForUserBody;
export type PatchUsersUserIdRiskDirectoriesMutationError = AxiosError<unknown>;

export const usePatchUsersUserIdRiskDirectories = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchUsersUserIdRiskDirectories>>,
            TError,
            { userId: UserId; data: UpdateRiskDirectoryRightsForUserBody },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchUsersUserIdRiskDirectories>>,
    TError,
    { userId: UserId; data: UpdateRiskDirectoryRightsForUserBody },
    TContext
> => {
    return useMutation(
        getPatchUsersUserIdRiskDirectoriesMutationOptions(options),
        queryClient
    );
};
export const getUsersUserIdSavedReports = (
    userId: UserId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<SavedReportForUserListDto>> => {
    return axios.get(`/api/users/${userId}/saved-reports`, options);
};

export const getGetUsersUserIdSavedReportsQueryKey = (userId: UserId) => {
    return [`/api/users/${userId}/saved-reports`] as const;
};

export const getGetUsersUserIdSavedReportsQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetUsersUserIdSavedReportsQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdSavedReports>>
    > = ({ signal }) =>
        getUsersUserIdSavedReports(userId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdSavedReportsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdSavedReports>>
>;
export type GetUsersUserIdSavedReportsQueryError = AxiosError<unknown>;

export function useGetUsersUserIdSavedReports<
    TData = Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdSavedReports>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdSavedReports<
    TData = Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdSavedReports>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdSavedReports<
    TData = Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdSavedReports<
    TData = Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdSavedReportsQueryOptions(
        userId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersUserIdSavedReportsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetUsersUserIdSavedReportsQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdSavedReports>>
    > = ({ signal }) =>
        getUsersUserIdSavedReports(userId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdSavedReportsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdSavedReports>>
>;
export type GetUsersUserIdSavedReportsSuspenseQueryError = AxiosError<unknown>;

export function useGetUsersUserIdSavedReportsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdSavedReportsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdSavedReportsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdSavedReportsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
    TError = AxiosError<unknown>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdSavedReports>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdSavedReportsSuspenseQueryOptions(
        userId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const patchUsersUserIdSavedReports = (
    userId: UserId,
    updateSavedReportRightsForUserBody: UpdateSavedReportRightsForUserBody,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.patch(
        `/api/users/${userId}/saved-reports`,
        updateSavedReportRightsForUserBody,
        options
    );
};

export const getPatchUsersUserIdSavedReportsMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchUsersUserIdSavedReports>>,
        TError,
        { userId: UserId; data: UpdateSavedReportRightsForUserBody },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchUsersUserIdSavedReports>>,
    TError,
    { userId: UserId; data: UpdateSavedReportRightsForUserBody },
    TContext
> => {
    const mutationKey = ["patchUsersUserIdSavedReports"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchUsersUserIdSavedReports>>,
        { userId: UserId; data: UpdateSavedReportRightsForUserBody }
    > = (props) => {
        const { userId, data } = props ?? {};

        return patchUsersUserIdSavedReports(userId, data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchUsersUserIdSavedReportsMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchUsersUserIdSavedReports>>
>;
export type PatchUsersUserIdSavedReportsMutationBody =
    UpdateSavedReportRightsForUserBody;
export type PatchUsersUserIdSavedReportsMutationError = AxiosError<unknown>;

export const usePatchUsersUserIdSavedReports = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchUsersUserIdSavedReports>>,
            TError,
            { userId: UserId; data: UpdateSavedReportRightsForUserBody },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchUsersUserIdSavedReports>>,
    TError,
    { userId: UserId; data: UpdateSavedReportRightsForUserBody },
    TContext
> => {
    return useMutation(
        getPatchUsersUserIdSavedReportsMutationOptions(options),
        queryClient
    );
};
export const patchUsersUserIdUserGroups = (
    userId: UserId,
    changeUserGroupUsersForUserBody: ChangeUserGroupUsersForUserBody,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.patch(
        `/api/users/${userId}/user-groups`,
        changeUserGroupUsersForUserBody,
        options
    );
};

export const getPatchUsersUserIdUserGroupsMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchUsersUserIdUserGroups>>,
        TError,
        { userId: UserId; data: ChangeUserGroupUsersForUserBody },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchUsersUserIdUserGroups>>,
    TError,
    { userId: UserId; data: ChangeUserGroupUsersForUserBody },
    TContext
> => {
    const mutationKey = ["patchUsersUserIdUserGroups"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchUsersUserIdUserGroups>>,
        { userId: UserId; data: ChangeUserGroupUsersForUserBody }
    > = (props) => {
        const { userId, data } = props ?? {};

        return patchUsersUserIdUserGroups(userId, data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchUsersUserIdUserGroupsMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchUsersUserIdUserGroups>>
>;
export type PatchUsersUserIdUserGroupsMutationBody =
    ChangeUserGroupUsersForUserBody;
export type PatchUsersUserIdUserGroupsMutationError = AxiosError<unknown>;

export const usePatchUsersUserIdUserGroups = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchUsersUserIdUserGroups>>,
            TError,
            { userId: UserId; data: ChangeUserGroupUsersForUserBody },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchUsersUserIdUserGroups>>,
    TError,
    { userId: UserId; data: ChangeUserGroupUsersForUserBody },
    TContext
> => {
    return useMutation(
        getPatchUsersUserIdUserGroupsMutationOptions(options),
        queryClient
    );
};
export const putUsersUserIdEmail = (
    userId: UserId,
    changeUserEmailBody: ChangeUserEmailBody,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<UserViewDto>> => {
    return axios.put(
        `/api/users/${userId}/email`,
        changeUserEmailBody,
        options
    );
};

export const getPutUsersUserIdEmailMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof putUsersUserIdEmail>>,
        TError,
        { userId: UserId; data: ChangeUserEmailBody },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof putUsersUserIdEmail>>,
    TError,
    { userId: UserId; data: ChangeUserEmailBody },
    TContext
> => {
    const mutationKey = ["putUsersUserIdEmail"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof putUsersUserIdEmail>>,
        { userId: UserId; data: ChangeUserEmailBody }
    > = (props) => {
        const { userId, data } = props ?? {};

        return putUsersUserIdEmail(userId, data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PutUsersUserIdEmailMutationResult = NonNullable<
    Awaited<ReturnType<typeof putUsersUserIdEmail>>
>;
export type PutUsersUserIdEmailMutationBody = ChangeUserEmailBody;
export type PutUsersUserIdEmailMutationError = AxiosError<unknown>;

export const usePutUsersUserIdEmail = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof putUsersUserIdEmail>>,
            TError,
            { userId: UserId; data: ChangeUserEmailBody },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof putUsersUserIdEmail>>,
    TError,
    { userId: UserId; data: ChangeUserEmailBody },
    TContext
> => {
    return useMutation(
        getPutUsersUserIdEmailMutationOptions(options),
        queryClient
    );
};
export const getUsersUserIdTestingActivities = (
    userId: UserId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<TActTableRowListDto>> => {
    return axios.get(`/api/users/${userId}/testing-activities`, options);
};

export const getGetUsersUserIdTestingActivitiesQueryKey = (userId: UserId) => {
    return [`/api/users/${userId}/testing-activities`] as const;
};

export const getGetUsersUserIdTestingActivitiesQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdTestingActivitiesQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>
    > = ({ signal }) =>
        getUsersUserIdTestingActivities(userId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdTestingActivitiesQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>
>;
export type GetUsersUserIdTestingActivitiesQueryError = AxiosError<null>;

export function useGetUsersUserIdTestingActivities<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdTestingActivities<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdTestingActivities<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdTestingActivities<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdTestingActivitiesQueryOptions(
        userId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersUserIdTestingActivitiesSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdTestingActivitiesQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>
    > = ({ signal }) =>
        getUsersUserIdTestingActivities(userId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdTestingActivitiesSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>
>;
export type GetUsersUserIdTestingActivitiesSuspenseQueryError =
    AxiosError<null>;

export function useGetUsersUserIdTestingActivitiesSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdTestingActivitiesSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdTestingActivitiesSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdTestingActivitiesSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingActivities>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdTestingActivitiesSuspenseQueryOptions(
        userId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getUsersUserIdTestingControls = (
    userId: UserId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<SimpleTestingControlListDto>> => {
    return axios.get(`/api/users/${userId}/testing-controls`, options);
};

export const getGetUsersUserIdTestingControlsQueryKey = (userId: UserId) => {
    return [`/api/users/${userId}/testing-controls`] as const;
};

export const getGetUsersUserIdTestingControlsQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdTestingControlsQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdTestingControls>>
    > = ({ signal }) =>
        getUsersUserIdTestingControls(userId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdTestingControlsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdTestingControls>>
>;
export type GetUsersUserIdTestingControlsQueryError = AxiosError<null>;

export function useGetUsersUserIdTestingControls<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdTestingControls>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdTestingControls<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdTestingControls>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdTestingControls<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdTestingControls<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdTestingControlsQueryOptions(
        userId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersUserIdTestingControlsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdTestingControlsQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdTestingControls>>
    > = ({ signal }) =>
        getUsersUserIdTestingControls(userId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdTestingControlsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdTestingControls>>
>;
export type GetUsersUserIdTestingControlsSuspenseQueryError = AxiosError<null>;

export function useGetUsersUserIdTestingControlsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdTestingControlsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdTestingControlsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdTestingControlsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdTestingControlsSuspenseQueryOptions(
        userId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getUsersUserIdTestingPrograms = (
    userId: UserId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<TestingProgramForUserListDto>> => {
    return axios.get(`/api/users/${userId}/testing-programs`, options);
};

export const getGetUsersUserIdTestingProgramsQueryKey = (userId: UserId) => {
    return [`/api/users/${userId}/testing-programs`] as const;
};

export const getGetUsersUserIdTestingProgramsQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdTestingProgramsQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>
    > = ({ signal }) =>
        getUsersUserIdTestingPrograms(userId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: userId !== null && userId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdTestingProgramsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>
>;
export type GetUsersUserIdTestingProgramsQueryError = AxiosError<null>;

export function useGetUsersUserIdTestingPrograms<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdTestingPrograms<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdTestingPrograms<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdTestingPrograms<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdTestingProgramsQueryOptions(
        userId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersUserIdTestingProgramsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetUsersUserIdTestingProgramsQueryKey(userId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>
    > = ({ signal }) =>
        getUsersUserIdTestingPrograms(userId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersUserIdTestingProgramsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>
>;
export type GetUsersUserIdTestingProgramsSuspenseQueryError = AxiosError<null>;

export function useGetUsersUserIdTestingProgramsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdTestingProgramsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersUserIdTestingProgramsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersUserIdTestingProgramsSuspense<
    TData = Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
    TError = AxiosError<null>,
>(
    userId: UserId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersUserIdTestingPrograms>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersUserIdTestingProgramsSuspenseQueryOptions(
        userId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getUsers = (
    params?: GetUsersParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<UserListResponse>> => {
    return axios.get(`/api/users`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetUsersQueryKey = (params?: GetUsersParams) => {
    return [`/api/users`, ...(params ? [params] : [])] as const;
};

export const getGetUsersQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsers>>,
    TError = AxiosError<unknown>,
>(
    params?: GetUsersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUsersQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({
        signal,
    }) => getUsers(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsers>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsers>>
>;
export type GetUsersQueryError = AxiosError<unknown>;

export function useGetUsers<
    TData = Awaited<ReturnType<typeof getUsers>>,
    TError = AxiosError<unknown>,
>(
    params: undefined | GetUsersParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsers>>,
                    TError,
                    Awaited<ReturnType<typeof getUsers>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsers<
    TData = Awaited<ReturnType<typeof getUsers>>,
    TError = AxiosError<unknown>,
>(
    params?: GetUsersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsers>>,
                    TError,
                    Awaited<ReturnType<typeof getUsers>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsers<
    TData = Awaited<ReturnType<typeof getUsers>>,
    TError = AxiosError<unknown>,
>(
    params?: GetUsersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsers<
    TData = Awaited<ReturnType<typeof getUsers>>,
    TError = AxiosError<unknown>,
>(
    params?: GetUsersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsers>>,
    TError = AxiosError<unknown>,
>(
    params?: GetUsersParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsers>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetUsersQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({
        signal,
    }) => getUsers(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsers>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsers>>
>;
export type GetUsersSuspenseQueryError = AxiosError<unknown>;

export function useGetUsersSuspense<
    TData = Awaited<ReturnType<typeof getUsers>>,
    TError = AxiosError<unknown>,
>(
    params: undefined | GetUsersParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsers>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersSuspense<
    TData = Awaited<ReturnType<typeof getUsers>>,
    TError = AxiosError<unknown>,
>(
    params?: GetUsersParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsers>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersSuspense<
    TData = Awaited<ReturnType<typeof getUsers>>,
    TError = AxiosError<unknown>,
>(
    params?: GetUsersParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsers>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersSuspense<
    TData = Awaited<ReturnType<typeof getUsers>>,
    TError = AxiosError<unknown>,
>(
    params?: GetUsersParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsers>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersSuspenseQueryOptions(params, options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postUsers = (
    createUserData: CreateUserData,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<UserWithSettingsResource>> => {
    return axios.post(`/api/users`, createUserData, options);
};

export const getPostUsersMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postUsers>>,
        TError,
        { data: CreateUserData },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postUsers>>,
    TError,
    { data: CreateUserData },
    TContext
> => {
    const mutationKey = ["postUsers"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postUsers>>,
        { data: CreateUserData }
    > = (props) => {
        const { data } = props ?? {};

        return postUsers(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostUsersMutationResult = NonNullable<
    Awaited<ReturnType<typeof postUsers>>
>;
export type PostUsersMutationBody = CreateUserData;
export type PostUsersMutationError = AxiosError<unknown>;

export const usePostUsers = <TError = AxiosError<unknown>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postUsers>>,
            TError,
            { data: CreateUserData },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postUsers>>,
    TError,
    { data: CreateUserData },
    TContext
> => {
    return useMutation(getPostUsersMutationOptions(options), queryClient);
};
export const patchUsers = (
    updatableUsers: UpdatableUsers,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.patch(`/api/users`, updatableUsers, options);
};

export const getPatchUsersMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchUsers>>,
        TError,
        { data: UpdatableUsers },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchUsers>>,
    TError,
    { data: UpdatableUsers },
    TContext
> => {
    const mutationKey = ["patchUsers"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchUsers>>,
        { data: UpdatableUsers }
    > = (props) => {
        const { data } = props ?? {};

        return patchUsers(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchUsersMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchUsers>>
>;
export type PatchUsersMutationBody = UpdatableUsers;
export type PatchUsersMutationError = AxiosError<unknown>;

export const usePatchUsers = <TError = AxiosError<unknown>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchUsers>>,
            TError,
            { data: UpdatableUsers },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchUsers>>,
    TError,
    { data: UpdatableUsers },
    TContext
> => {
    return useMutation(getPatchUsersMutationOptions(options), queryClient);
};
export const getUsersAssignmentCounts = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<GetUsersAssignmentCounts200>> => {
    return axios.get(`/api/users/assignment-counts`, options);
};

export const getGetUsersAssignmentCountsQueryKey = () => {
    return [`/api/users/assignment-counts`] as const;
};

export const getGetUsersAssignmentCountsQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetUsersAssignmentCountsQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersAssignmentCounts>>
    > = ({ signal }) => getUsersAssignmentCounts({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersAssignmentCountsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersAssignmentCounts>>
>;
export type GetUsersAssignmentCountsQueryError = AxiosError<unknown>;

export function useGetUsersAssignmentCounts<
    TData = Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersAssignmentCounts>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersAssignmentCounts<
    TData = Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
                    TError,
                    Awaited<ReturnType<typeof getUsersAssignmentCounts>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersAssignmentCounts<
    TData = Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersAssignmentCounts<
    TData = Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetUsersAssignmentCountsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetUsersAssignmentCountsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetUsersAssignmentCountsQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getUsersAssignmentCounts>>
    > = ({ signal }) => getUsersAssignmentCounts({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsersAssignmentCountsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getUsersAssignmentCounts>>
>;
export type GetUsersAssignmentCountsSuspenseQueryError = AxiosError<unknown>;

export function useGetUsersAssignmentCountsSuspense<
    TData = Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersAssignmentCountsSuspense<
    TData = Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsersAssignmentCountsSuspense<
    TData = Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetUsersAssignmentCountsSuspense<
    TData = Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getUsersAssignmentCounts>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetUsersAssignmentCountsSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postUsersInvite = (
    userId: UserId[],
    options?: AxiosRequestConfig
): Promise<AxiosResponse<UserId[]>> => {
    return axios.post(`/api/users/invite`, userId, options);
};

export const getPostUsersInviteMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postUsersInvite>>,
        TError,
        { data: UserId[] },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postUsersInvite>>,
    TError,
    { data: UserId[] },
    TContext
> => {
    const mutationKey = ["postUsersInvite"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postUsersInvite>>,
        { data: UserId[] }
    > = (props) => {
        const { data } = props ?? {};

        return postUsersInvite(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostUsersInviteMutationResult = NonNullable<
    Awaited<ReturnType<typeof postUsersInvite>>
>;
export type PostUsersInviteMutationBody = UserId[];
export type PostUsersInviteMutationError = AxiosError<unknown>;

export const usePostUsersInvite = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postUsersInvite>>,
            TError,
            { data: UserId[] },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postUsersInvite>>,
    TError,
    { data: UserId[] },
    TContext
> => {
    return useMutation(getPostUsersInviteMutationOptions(options), queryClient);
};
